var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H513V341.993H0V-0.00683594Z",
    fill: "#1B4991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.2 106.693V213.193C318.2 265.093 386 280.993 386 280.993C386 280.993 453.8 265.093 453.8 213.193V106.693H318.2Z",
    fill: "#00A2B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.7 105.193H455.3V213.193C455.3 239.903 437.829 257.252 420.688 267.832C412.101 273.133 403.526 276.783 397.105 279.108C393.892 280.272 391.211 281.106 389.33 281.65C388.389 281.922 387.648 282.122 387.139 282.254C386.885 282.32 386.688 282.369 386.554 282.402C386.487 282.419 386.436 282.432 386.4 282.44L386.359 282.45L386.344 282.453C386.343 282.454 386.343 282.454 386 280.993C385.658 282.454 385.657 282.454 385.656 282.453L385.641 282.45L385.6 282.44C385.565 282.432 385.513 282.419 385.446 282.402C385.312 282.369 385.116 282.32 384.861 282.254C384.352 282.122 383.611 281.922 382.67 281.65C380.789 281.106 378.109 280.272 374.896 279.108C368.475 276.783 359.9 273.133 351.312 267.832C334.172 257.252 316.7 239.903 316.7 213.193V105.193ZM386 280.993L385.658 282.454L386 282.534L386.343 282.454L386 280.993ZM386 279.449C386.105 279.422 386.233 279.39 386.384 279.35C386.868 279.224 387.584 279.032 388.497 278.768C390.323 278.24 392.94 277.426 396.083 276.288C402.375 274.01 410.75 270.441 419.112 265.279C435.872 254.935 452.3 238.383 452.3 213.193V108.193H319.7V213.193C319.7 238.383 336.129 254.935 352.888 265.279C361.251 270.441 369.626 274.01 375.917 276.288C379.06 277.426 381.677 278.24 383.504 278.768C384.417 279.032 385.132 279.224 385.616 279.35C385.767 279.39 385.895 279.422 386 279.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.7 212.693C319.7 263.493 386 278.993 386 278.993C386 278.993 452.3 263.393 452.3 212.693H319.7Z",
    fill: "#A35023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.1 155.093H395.7V135.693H376.3V155.093H357V174.493H376.3V232.593H395.7V174.493H415.1V155.093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 -0.00683594V30.5932L210.8 55.6932H256V114.993H196.9L256 147.793V170.693H229.3L155.8 129.793V170.693H100.2V122.093L12.7 170.693H0V140.093L45.2 114.993H0V55.6932H59.1L0 22.7932V-0.00683594H26.7L100.2 40.7932V-0.00683594H155.8V48.5932L243.3 -0.00683594H256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 -0.00683594H112V69.2932H0V101.293H112V170.693H144V101.293H256V69.2932H144V-0.00683594Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.8 114.993L256 170.693V154.893L184.2 114.993H155.8Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.8 114.993L256 170.693V154.893L184.2 114.993H155.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.8 114.993L256 170.693V154.893L184.2 114.993H155.8ZM71.8 114.993L0 154.893V170.693L100.2 114.993H71.8Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 55.5932L0 -0.00683594V15.6932L71.8 55.5932H100.2Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 55.5932L0 -0.00683594V15.6932L71.8 55.5932H100.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 55.5932L0 -0.00683594V15.6932L71.8 55.5932H100.2ZM184.2 55.5932L256 15.6932V-0.00683594L155.8 55.5932H184.2Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/MS.7eef34a283a215ede7e1352df43074f1.svg";
export { ForwardRef as ReactComponent };